// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__RzH+T","pillLarge":"Pill_pillLarge__5qo2g"};